import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/config";

export const WhatsAppFloat = () => (
    <motion.a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Hablar por WhatsApp"
        data-testid="floating-whatsapp-btn"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.92 }}
        className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-wa text-white shadow-2xl shadow-brand-wa/40"
    >
        <span aria-hidden="true" className="animate-wa-ping absolute inset-0 rounded-full bg-brand-wa" />
        <MessageCircle className="relative h-7 w-7" strokeWidth={2.2} />
    </motion.a>
);
